var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attachment.thumbImageUrl) ? _c('div', {
    staticClass: "thumbnail"
  }, [_c('a', {
    attrs: {
      "href": _vm.attachment.url,
      "data-type": "image",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "thumbnail__image",
    attrs: {
      "alt": _vm.altText,
      "src": _vm.attachment.thumbImageUrl
    }
  })])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a05481","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Thumbnail.vue
// module id = 1988
// module chunks = 0